let config = {
    romeUi: 'http://localhost:8080',
    romeApi: 'http://localhost:5000',
    romeUrl: 'http://localhost:49370',
    buildNumber: '1.0.1-local',
    romeLogin: '',
    romeLogout: '',
    romeSsoSession: '',
    luckyOrangeSiteId: "LuckyOrangeSPA",
    clientName: "spa"
};

export { config }



// WEBPACK FOOTER //
// ./src/config.js